import send from '../utils/send';
import ServerApiError from '../error/serverApiError';

class RegisterService {
    async register(data) {
        const result = await send("/register", "POST", {}, data)
        if (result instanceof ServerApiError) {
            result.alert();
            return {};
        }
        return { status: result.status, data: result.data }
    }
    async verifyRegister(data) {
        const result = await send("/register/verify", "POST", {}, data);
        if (result instanceof ServerApiError) {
            result.alert();
            return {};
        }
        return { status: result.status, data: result.data }
    }
    async resendCodeToEmail(data){
        const result = await send("/register/resendCode", "POST", {}, data)
        if (result instanceof ServerApiError) {
            result.alert();
            return {};
        }
        return { status: result.status }
    }
    async createCampaign(data) {
        const form = new FormData();
        form.append("csvFile", data.csvFile);
        form.append("audioFile", data.audioFile);
        form.append("id", data.accountId);
        form.append("csvArray",JSON.stringify(data.csvArray));
        form.append("comax_card_token", data.comaxCardToken);
        form.append("date", data.date);
        form.append("time", data.time);
        form.append("recivefeedback",data.recivefeedback);
        const headers = {
            'Content-Type': 'multipart/form-data',
        }
        const result = await send("/register/createCampaign", "PUT", headers, form);
        if (result instanceof ServerApiError) {
            result.alert();
            return {status: result.status};
        }
        return { status: result.status, data: result.data }
    }
}

export default RegisterService;